import PostalCodeData from "../config/PostalCodeData.json";

export function validateExperienceTitle(value = "") {
  const regex = /^[a-zA-Z\d\W ,.'-_]+$/u;
  const str = value.trim();
  const messages = [];

  if (!str || !regex.test(str)) {
    messages.push("Invalid");
  }

  return messages;
}

export function validateMediaItemName(value = "") {
  const regex = /^[a-zA-Z\d\W ,.'-]+$/u;
  const str = value.trim();
  const messages = [];

  if (!str || !regex.test(str)) {
    messages.push("Invalid");
  }

  return messages;
}

export function validateTag(value = "") {
  const regex = /^[\S ]+$/u;
  const str = value.trim();
  const messages = [];

  if (str.length === 0) {
    messages.push("Too short");
  }

  if (str.length >= 129) {
    messages.push("Too long");
  }

  if (!regex.test(str)) {
    messages.push("Invalid");
  }

  if (str.toLowerCase() === "other") {
    messages.push("Invalid name");
  }

  return messages;
}

export function validateVimeoURL(value = "") {
  const regex =
    /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i;
  return regex.test(value);
}

export function validateZipCode(value = "") {
  return PostalCodeData.reduce((res, { __text }) => {
    const regEx = new RegExp(`^${__text}$`);
    return res || regEx.test(value);
  }, false);
}
